<style scoped>
    p
    {
        font-size: 13px;
        color: #6E7191;
    }

    .declaration-table {
        flex-wrap: wrap;
        gap: 0.85rem;
    }

    .biz-detail-tab {
        flex: 1;
    }

    .declaration-details .items,
    .declaration-details .items-list {
        flex: 1;
    }


    .insurance-check-bar {
        flex: 1;
    }

    .insurance-check-bar-content {
        display: flex;
        /* justify-content: space-between; */
    }

    .insurance-check-bar-content:not(:last-child) {
        border-bottom: 1px solid #d1d3e2;
        margin: 1rem auto;
    }



</style>
<template>
  <register-container :step="step">
      <div class="card-body">
          <h1 class="head-title text-center font-weight-bold">Declarations</h1>
          <p style="color: #4E4B66;" class="mb-5 text-center">
              Review the information below and confirm they are accurate
          </p>

          <hr style="margin-bottom: 2rem;"/>

          <div class="d-flex justify-content-between declaration-table">
              <div class="biz-detail-tab">
                  <h3 style="font-weight: 800; font-size: 18px; color: #000;" class="font-weight-bold mb-4">
                      Business Details
                  </h3>
                  <div class="declaration-details d-flex items-table">
                      <div class="items">
                          <p class="">Business Name: </p>
                          <p>Phone:</p>
                          <p>Position: </p>
                          <p>ABN:</p>
                          <p>Address:</p>
                          <p>Number of Employees:</p>
                          <p>Category:</p>
                      </div>

                      <div class="items-list ml-2">
                          <p>{{ business.company_name }}</p>
                          <p>{{ business.phone }}</p>
                          <p>{{ business.position }}</p>
                          <p>{{ business.abn_acn }}</p>
                          <p>{{ business.address }}</p>
                          <p>{{ business.min_employees }} -
                              {{ business.max_employees }}</p>
                          <p
                              v-for="category in business.categories"
                              :key="'cat-' + category.id"
                          >{{ category.name }}</p>
                      </div>
                  </div>


              </div>

              <div class="insurance-check-bar">
                  <h3
                      class="mb-4"
                      style="font-weight: 800; font-size: 18px; color: #333333;"

                  >
                      Insurance
                  </h3>

                  <div class="insurance-check-bar-content"
                       v-for="insurance in business.insurances"
                       :key="'ins-' + insurance.id"
                  >
                      <table class="table-key-value spacing-5">
                          <tr>
                              <td><p>Insurance Type: </p></td>
                              <td>
                                  <p v-if="insurance.insurance_type == 'public-liability'">Public Liability</p>
                                  <p v-if="insurance.insurance_type == 'workers-compensation'">Workers Compensation</p>
                                  <p v-if="insurance.insurance_type == 'professional-indemnity'">Professional Indemnity</p>
                                  <p v-if="insurance.insurance_type == 'other-insurances'">Other Insurances</p>
                              </td>
                          </tr>
                          <tr>
                              <td><p>Policy Number: </p></td>
                              <td><p>{{ insurance.insurance_policy }}</p></td>
                          </tr>
                          <tr>
                              <td><p>Limit($): </p></td>
                              <td><p>{{ insurance.insurance_limit ? insurance.insurance_limit.toLocaleString() : '' }}</p></td>
                          </tr>
                          <tr>
                              <td><p>Expire: </p></td>
                              <td><p>{{ insurance.insurance_expiry ? changeDateFormat(insurance.insurance_expiry) : '' }}</p></td>
                          </tr>
                          <tr>
                              <td><p>Document(S): </p></td>
                              <td><p><a v-for="(media, idx) in insurance.media" target="_blank" :key="'ins-med-'+idx" :href="media.signed_url" download>{{ media.name }}</a>&nbsp;</p></td>
                          </tr>
                      </table>
                  </div>
              </div>

          </div>


          <hr class="mt-3" />
          <p class="text-center" style="font-size: 16px;">
              <b-form-checkbox size="sm" id="check" value="1" checked="1">I do hereby declare that all the information given above is true to the best of my knowledge and belief.</b-form-checkbox>
          </p>

          <div class="text-center my-4 dec-btns">
              <b-button
                  type="button"
                  variant="outline-primary"
                  class="back-btn"
                  @click="$router.go(-1)"
              >
                  Back
              </b-button>

              <b-button
                  type="button"
                  class="btn-grad"
                  style="display:inline-block;"
                  variant="primary"
                  :to="{ name: 'register-contractor', params: { step: 6 } }"
              >Agree and Proceed</b-button
              >
          </div>
      </div>
  </register-container>
</template>

<script>

import SideBar from "../includes/SideBar.vue";
import FooterComponent from "../../../../pages/includes/FooterComponent.vue";
import moment from "moment";
import RegisterContainer from "./RegisterContainer.vue";
export default {
    props: ["step",'sidebarListLinks'],
    components: {
        RegisterContainer,
        FooterComponent,
        SideBar
    },
    data() {
        return {
            business: {}
        };
    },
    mounted() {
        this.fetchBusinessData();
    },
    methods: {
        fetchBusinessData() {
            this.$root.$data.bsLoader = true;
            axios
                .post("api/contractor/business/getDetails", {
                    load_categories: 1,
                    load_insurances: 1,
                    load_insurances_media: 1,
                })
                .then(response => {
                    if(response.data.business == 'empty'){              //Redirecting into business page if business is not created
                        this.$router.push({
                            name: "register-contractor",
                            params: {step: 2},
                        });
                    }else{
                        this.business = response.data.business;
                    }
                    this.$root.$data.bsLoader = false;
                }).catch((err) => {
                    this.$root.$data.bsLoader = false;
                });
        },
        changeDateFormat(date){
          return moment(date).format("DD-MM-YYYY");
        }
    }
};
</script>

<style scoped>
.dec-btns {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    row-gap: 5px;
}
</style>
